var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgWarningHollow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2822 3.04687C11.8235 2.10937 13.1766 2.10938 13.7179 3.04688L22.1616 17.6719C22.7029 18.6094 22.0263 19.7812 20.9438 19.7812H4.0563C2.97377 19.7812 2.29718 18.6094 2.83845 17.6719L11.2822 3.04687ZM13.2308 3.32813C12.906 2.76563 12.0941 2.76562 11.7693 3.32812L3.32559 17.9531C3.00083 18.5156 3.40678 19.2188 4.0563 19.2188H20.9438C21.5933 19.2188 21.9993 18.5156 21.6745 17.9531L13.2308 3.32813ZM12.5001 13.0312C12.3447 13.0312 12.2188 12.9053 12.2188 12.75V8.25C12.2188 8.09467 12.3447 7.96875 12.5001 7.96875C12.6554 7.96875 12.7813 8.09467 12.7813 8.25V12.75C12.7813 12.9053 12.6554 13.0312 12.5001 13.0312ZM12.2188 16.5C12.2188 16.6553 12.3447 16.7812 12.5001 16.7812C12.6554 16.7812 12.7813 16.6553 12.7813 16.5V15.75C12.7813 15.5946 12.6554 15.4687 12.5001 15.4687C12.3447 15.4687 12.2188 15.5946 12.2188 15.75V16.5Z",
    fill: "#D1D2D3"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningHollow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-hollow.2b0a521797a8b32d62d25d769b9a1e18.svg";